import React from "react";

function Button({
  img,
  btn,
  btnPadding,
  textColor = "text-primary",
  bgColor = "bg-secondary",
  btnRound = "rounded-md",
  onClick,
  type = "button",
  disabled = false,
  className = "",
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`w-auto flex gap-2 justify-center items-center ${btnRound} ${textColor} ${bgColor} ${btnPadding} text-sm text-center border-none outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 transition duration-200 ${
        disabled
          ? "opacity-50 cursor-not-allowed pointer-events-none"
          : "cursor-pointer"
      } ${className}`}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
          return;
        }
        onClick && onClick(e);
      }}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick && onClick(e);
        }
      }}
    >
      {img && <span className="text-xl">{img}</span>}
      {btn && btn}
    </button>
  );
}

export default Button;
